import React from 'react';
import VideoRecordingSummaryContainer from './VideoRecordingSummaryContainer';
import VideoRecordingContainer from './VideoRecordingContainer';
import { MeetingRecordingDocument } from 'types';

interface Props {
	recordings: MeetingRecordingDocument[];
}

const InterviewSummaryAndVideoRecording = ({ recordings }: Props) => {
	// showSummary is a temporary variable for now
	const showSummary = false;

	// temporary summary data
	const summaryData = `
			<div>
				<ul>
					<li>Candidate demonstrates strong motivation and enthusiasm.</li>
					<li>Strong aptitude in frontend skills and React programming.</li>
					<li>Requires improvement in logic building for algorithmic problem-solving.</li>
					<li>Demonstrates the ability to grasp new concepts quickly.</li>
					<li>Needs to further develop problem-solving skills in Data Structures and Algorithms.</li>
				</ul>
			</div>
		`;

	return (
		<>
			<div className={`${showSummary ? 'flex gap-6 sm:flex-col' : 'block'} `}>
				{showSummary ? (
					<div className="mt-6 w-[calc(100%-280px)] sm:w-full">
						<VideoRecordingSummaryContainer summary={summaryData} />
					</div>
				) : null}

				<div className={`mt-6 ${showSummary ? 'w-[254px] sm:w-full' : 'w-full'}`}>
					<VideoRecordingContainer isSummaryAvailable={!!showSummary} recordings={recordings} />
				</div>
			</div>
		</>
	);
};

export default InterviewSummaryAndVideoRecording;
